import { apiPath } from '@/services/apiPath';
import { safeAxios } from '@/services/safeAxios';
import type { CatalogTool } from '@/types/toolkit.types';

/** The public system tools among `toolIds`. An id with no public system tool behind it is not returned. */
export const getCatalogTools = async (toolIds: string[]): Promise<CatalogTool[]> => {
  const res = await safeAxios.get<{ tools: CatalogTool[] }>(apiPath`/v1/catalog/tools`, {
    params: { ids: toolIds.join(',') },
  });
  return res.data.tools;
};
